import * as z from "../../../vendor/zod/src/index";
export default z.object({
    session_token: z.string(),
});
